import Vue from 'vue';
import Component from 'vue-class-component';
import EdFormModel from '@/models/ed-form.model';
import EdInputModel from '@/models/ed-input.model';
import KEYS from '@/values/keys';
import { required  } from 'vuelidate/lib/validators';
import { Store, STORE } from '@/core/store/core.store';
import { ZipCodeService } from '@/services/zipcode.service';
import { i18n } from '@/core/lang/core.i18n';
import STATES from '@/core/values/states'

@Component({})
export default class InstitutionInformation extends Vue {

  /* Data */

  public form: any = [];
  public initialForm: any = [];
  public countriesList: any[] = [];
  public institutionList: any[] = [];
  public institutionSelected: any = null;
  public countrySelected: any = null;
  public isShow: boolean = false;
  public hasCorrectZipCode: boolean = false;
  public citiesList: any[] = [];
  public citySelected: any = null;
  public initialCity:any = null;
  public zipCodeLoading: boolean = false;

  /* Computed */

  get instutionInfo(): any[] {
    return Store.state.ToolsStore.institutionInfo
  }

  get instutionSDA(): any[] {
    return Store.state.ToolsStore.schoolDA.content
  }

  get countries(): any[] {
    return Store.state.ToolsStore.countries
  }

  get initFields(): any {
    let phones = [];
    let address = [];
    if(this.institutionSelected) {
      phones = this.institutionSelected.phones;
      address = this.institutionSelected.address;
    }
    return {
      name: this.institutionSelected ? this.institutionSelected.name || '' : '',
      webSite: this.institutionSelected ? this.institutionSelected.webSite || '' : '',
      phoneNumber: phones.length > 0 ? phones[0].phone || '' : '',      
      ext: phones.length > 0 ? phones[0].phoneExt || '' : '',      
      institutionAdress: address.length > 0 ? address[0].address1 || '' : '',      
      institutionAdress2: address.length > 0 ? address[0].address2 || '' : '',      
      institutionAdress3: address.length > 0 ? address[0].address3 || '' : '',      
      zipCode: address.length > 0 ? address[0].zipcode || '' : '',
      city: address.length > 0 ? address[0].city || '' : ''
    }
  } 

  get compareForms(): boolean {
    for (var key in this.form) {
      if (this.initialForm[key]!=undefined && (this.form[key].value != this.initialForm[key].value) && key != undefined) {
        return false;
      }
    }

    return true;
  }

  /* Methods */

  public init(name: string = '', webSite: string = '', phoneNumber: string = '', ext: number = 0, 
  institutionAdress: string = '', institutionAdress2: string = '',
  institutionAdress3: string = '' , state: string = '', city: string= '' , zipCode: number = 0): void {
    this.form = EdFormModel([
      EdInputModel('name', name , {required}),
      EdInputModel('webSite', webSite),
      EdInputModel('phoneNumber', phoneNumber, {required}),
      EdInputModel('ext', ext),
      EdInputModel('institutionAdress', institutionAdress, {required}),
      EdInputModel('institutionAdress2', institutionAdress2),
      EdInputModel('institutionAdress3', institutionAdress3),
      EdInputModel('state', state , {required}),       
      EdInputModel('city', city , {required}),       
      EdInputModel('zipCode', zipCode , {required}),       
    ]);
  }


  private setInstutionInfo(instList: any[]): void {
    let institutions: any = [];
    institutions = instList.map((i: any) => {
      return {
        ...i,
        key: i.organizationId,
        value: i.name
      }
    });
    this.institutionList = institutions;
    this.institutionList.unshift({key: 'Select', value: i18n.t('tools.institutionInfo.chooseInstitution')});
  }

  private setCountriesInfo(initList: any[]) {
    let countries: any = [];
    countries = initList.map((i: any) => {
      return {
        ...i,
        key: i.code,
        value: i.name
      }
    });
    this.countriesList = countries;
  }

  private setCitiesInfo(initList: any[]) {
    let cities: any = [];
    cities = initList.map((i: any) => {
      return {
        ...i,
        key: i,
        value: i
      }
    });
    this.citiesList = cities;
    this.citiesList.unshift({key: 'Select', value: i18n.t('tools.institutionInfo.chooseCity')});
  }

  private checkZipCode(zip: number,init = 0): void {
      this.hasCorrectZipCode = false;         
      this.zipCodeLoading = true;         
      ZipCodeService.verifyZipCode(zip)
      .then((res: any) => {
        let initialCityIndex = res.cities.indexOf(this.initialCity);
        if(res.cities.length > 0) {
          this.setCitiesInfo(res.cities);
          if(initialCityIndex!=-1){
            this.form.city.value = this.citiesList[initialCityIndex+1].value;
            this.citySelected = this.citiesList[initialCityIndex+1];
          }
          else{
            this.form.city.value = this.citiesList[1].value;
            this.citySelected = this.citiesList[1];
          } 
        }
        let state = STATES.find((s: any) => String(s.state) === String(res.state));            
        this.form.state.value = state.name;
        this.hasCorrectZipCode = true;
      })
      .catch(() => {
        this.form.zipCode.valid = false;
        this.form = {...this.form};
        this.showModal(i18n.t('tools.institutionInfo.registerTitle'), 
        i18n.t('tools.institutionInfo.errorZipCodeBody'), KEYS.EVENT_TYPES.DANGER);  
      }).finally(()=> {
        this.zipCodeLoading = false;
        if(init==1) {
          this.initialForm = JSON.parse(JSON.stringify(this.form));
        }
      });
  }

  private setFields(): void {
    const address = this.institutionSelected.address || [];
    this.init(
      this.initFields.name,
      this.initFields.webSite,
      this.initFields.phoneNumber,
      this.initFields.ext,
      this.initFields.institutionAdress, 
      this.initFields.institutionAdress2,
      this.initFields.institutionAdress3,
      '',
      this.initFields.city,
      this.initFields.zipCode
    );
    if(address.length > 0) {
      this.checkZipCode(address[0].zipcode,1);
    }
    this.initialCity = this.initFields.city;
    this.form.setValid('city', this.initialCity != '');
  }

  private showModal(tile: any, body: any, type: string) {
    this.$EdModal.createMessageModal({
      title: tile,
      body: body,
      type: type
    });
  }

  public selectInstitution(instution: any) {    
    (this.$refs.EdLoading as any).show();
    this.isShow = false;
    if (instution !== '') {
      this.institutionSelected = instution;
    }
    
    if (instution == '' || this.institutionSelected.key == 'Select') {
      this.institutionSelected = this.institutionList[1];
    }

    this.setFields();
    this.$store.dispatch(STORE.TOOLS.ACTIONS.GET_INSTITUTION_SDA, this.institutionSelected.organizationId)    
    .finally(() => {
      this.isShow = true;    
      (this.$refs.EdLoading as any).hide(); 
    }); 
  }

  public selectCountry(country: any) {
    this.countrySelected = country;
  }

  public selectCity(city:any){
    this.citySelected = city;
    this.form.city.value = city.value;
    this.form.setValid('city', city.key !== 'Select');
  }

  public formatPhoneNumber(): void {
    if (this.form.phoneNumber.value) {
      this.form.phoneNumber.value = this.form.phoneNumber.value.replace(/^(\+)?([^\d]*)|[^\d]/g, (match, plus) => plus ? '+' : '');
    }
  }
  public formatExtension(): void {
    if (this.form.ext.value) {
      this.form.ext.value = this.form.ext.value.replace(/[^0-9]/g, '');
    }
  }

  public saveForm(): void {

    let currentSelected = this.institutionList.indexOf(this.institutionSelected);

    (this.$refs.EdLoading as any).show();

    let data: any = {      
      name: this.form.name.value,
      webSite: this.form.webSite.value,
      phoneNumber: this.form.phoneNumber.value,
      ext: this.form.ext.value,
      institutionAdress: this.form.institutionAdress.value,
      institutionAdress2: this.form.institutionAdress2.value,
      institutionAdress3: this.form.institutionAdress3.value,
      zipCode: this.form.zipCode.value,
      state: this.form.state.value,
      city: this.form.city.value,
      countryCode: this.countrySelected.code,
      /* Not modifiable by the form */
      organizationId: this.institutionSelected.organizationId,
      typeId: this.institutionSelected.typeId,
      status: this.institutionSelected.status ? this.institutionSelected.status : 'INACTIVE',
      ein: this.institutionSelected.ein,
      registeredEnterprise: this.institutionSelected.registeredEnterprise,
      categories: this.institutionSelected.categories,
      organizationParentId: this.institutionSelected.organizationParentId ? this.institutionSelected.organizationParentId : ''
    }
    
    this.$store.dispatch(STORE.TOOLS.ACTIONS.UPDATE_INSTITUTION_INFO, data)
    .then(() => {
      this.setInstutionInfo(this.instutionInfo);
      this.showModal(i18n.t('tools.institutionInfo.registerTitle'), 
        i18n.t('tools.institutionInfo.successChanges'), KEYS.EVENT_TYPES.SUCCESS);  
    })
    .catch(() => {
      this.showModal(i18n.t('tools.institutionInfo.registerTitle'), 
        i18n.t('tools.institutionInfo.unSuccesChanges'), KEYS.EVENT_TYPES.DANGER);
    })
    .finally(() => {
      this.selectInstitution(this.institutionList[currentSelected]);
      this.institutionSelected = this.institutionList[currentSelected];
      this.form = {...this.form};
      this.initialForm = JSON.parse(JSON.stringify(this.form));
      (this.$refs.EdLoading as any).hide();
    });
  }

  /* Hooks */
  async mounted() {
    const EdLoading: any = this.$refs.EdLoading; 
    try {
      EdLoading.show();
      this.init();
      this.setInstutionInfo(this.instutionInfo);
      this.institutionSelected = this.institutionList[1];    
      this.setFields();
      await this.$store.dispatch(STORE.TOOLS.ACTIONS.GET_COUNTRIES);    
      await this.$store.dispatch(STORE.TOOLS.ACTIONS.GET_INSTITUTION_SDA, this.institutionSelected.organizationId);
      this.setCountriesInfo(this.countries);
      this.countrySelected = this.countriesList[0];
      this.isShow = true;
      EdLoading.hide();
    } catch(err) {
      this.showModal(
        i18n.t('tools.toolbar.institutionInformation'), 
        i18n.t('tools.institutionInfo.errorGettingInfo'),
        KEYS.EVENT_TYPES.DANGER
      );
      EdLoading.hide();
    }    
  }
}
